import type { DimensionKey } from "./dimensions";
import {
  growthRecords,
  type GrowthDiary,
  type GrowthRecord,
} from "./recordsModel";
import { recordDay } from "../../../components/dailyHubModel";

export interface DimensionRecord {
  key: string;
  title: string;
  content: string;
  day: string;
  label: string;
  goalId?: number;
  record?: GrowthRecord;
}

// These are existing record categories, not guesses made from a user's text.
export function diariesForDimension(key: DimensionKey, diaries: GrowthDiary[]) {
  return diaries.filter((d) => {
    if (key === "bond") return !!d.person_id;
    const types = {
      body: "fitness",
      heart: "mood",
      intellect: "note",
      craft: "tech",
    };
    return key !== "purpose" && (d.diary_type || "note") === types[key];
  });
}

export function dimensionRecords(
  key: DimensionKey,
  diaries: GrowthDiary[],
  meals: any[] = [],
  sessions: any[] = [],
): DimensionRecord[] {
  return growthRecords(
    diariesForDimension(key, diaries),
    key === "body" ? meals : [],
    key === "body" ? sessions : [],
  ).map((record) => ({
    ...record,
    record,
    label: record.diary?.person_name
      ? `${record.label} · ${record.diary.person_name}`
      : record.label,
  }));
}

export function goalRecords(goals: any[]): DimensionRecord[] {
  return goals
    .slice()
    .sort(
      (a, b) =>
        (new Date(b.updated_at || b.created_at).getTime() || 0) -
          (new Date(a.updated_at || a.created_at).getTime() || 0) ||
        b.id - a.id,
    )
    .map((goal) => ({
      key: `goal:${goal.id}`,
      goalId: goal.id,
      title: goal.title,
      content: `${goal.description || "为这个目标留下一次回顾。"}\n进度 ${goal.progress ?? 0}% · ${goal.last_reviewed_at ? `最近复盘 ${recordDay(goal.last_reviewed_at)}` : "尚未复盘"}`,
      day: recordDay(goal.updated_at || goal.created_at),
      label:
        (
          {
            active: "进行中",
            completed: "已完成",
            paused: "已暂停",
            abandoned: "已放下",
          } as Record<string, string>
        )[goal.status] || "目标",
    }));
}
